import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './i18n/en.json';
import sq from './i18n/sq.json';

export const languages = ['sq', 'en'];
export const languagesId = { sq: 1, en: 2 };

export const getLanguageId = () =>
  languagesId[i18next.language] || languagesId[window.localStorage.i18nextLng];

if (!window.localStorage.getItem('locale'))
  window.localStorage.setItem('locale', 'sq');

const langDetectorOptions = {
  // order and from where user language should be detected
  order: ['localStorage', 'cookie', 'navigator'],

  // keys or params to lookup language from
  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',

  // cache user language on
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)

  checkWhitelist: true,
};
const i18nConfig = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      sq: {
        translation: sq,
      },
    },
    fallbackLng: 'en',
    // debug: true,
    whitelist: languages,
    detection: langDetectorOptions,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18nConfig;
